import {
  DirectoryDropItem,
  DropEvent as DropEventAria,
  DropOptions as DropOptionsAria,
  FileDropItem,
  TextDropItem,
  useDrop as useDropAria
} from 'react-aria'
import {isDirectoryDropItem, isFileDropItem, isTextDropItem} from '../utils/predicates'

type DropItems = {
  textItems?: TextDropItem[]
  fileItems?: FileDropItem[]
  directoryItems?: DirectoryDropItem[]
}

// override the items type
type DropEvent = Omit<DropEventAria, 'items'> & DropItems

// override the onDrop callback
type DropOptions = Omit<DropOptionsAria, 'hasDropButton' | 'onDrop'> & {onDrop?: (e: DropEvent) => void}

const useDrop = (options: DropOptions) => {
  async function onDrop(e: DropEventAria) {
    const textItems = e.items.filter(isTextDropItem)
    const fileItems = e.items.filter(isFileDropItem)
    const directoryItems = e.items.filter(isDirectoryDropItem)

    const items = {
      textItems,
      fileItems,
      directoryItems
    }
    if (options.onDrop) {
      options.onDrop({...e, ...items})
    }
  }

  const dropResults = useDropAria({...options, onDrop})

  return dropResults
}

export default useDrop
